// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding: 20px;
  
}

.dashboard-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 300px; /* Set a fixed height for the content area to ensure both items are aligned */
}

.dashboard-image {
  width: 50%; /* Takes 50% of parent width */
  text-align: center;
  height: 100%; /* Ensures the image div takes up full height */
}

.dashboard-chart {
  width: 50%; /* Takes 50% of parent width */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Ensures the chart div takes up full height */
}

/* Adjust the image to fill the parent height */
.dashboard-image img {
  max-width: 100%;
  height: 100%; /* Make sure the image takes the full height of its container */
  object-fit: contain; /* Maintains aspect ratio and fits within the container */
}

/* Ensure doughnut chart canvas fills its container */
.dashboard-chart canvas {
  width: 100% !important;
  height: 100% !important; /* Ensures the chart fills its container's height */
}

@media (max-width: 768px) {
  .dashboard-content {
    flex-direction: row; /* Ensures both items stay in a row on mobile */
    height: auto; /* Allow flexible height on smaller screens */
  }

  .dashboard-image, .dashboard-chart {
    width: 50%; /* Keep them side by side */
    height: auto; /* Allow flexible height */
  }
}


/* ======================================= */
/* General styling for the dashboard */
.Staff-dashboard-container {
  width: 90%;
  margin: 20px auto; /* Center the container */
  display: flex;
  flex-direction: column;
  gap: 20px;
}




.dashboard-card {
  width: 100%;
  border-radius: 10px;
  padding: 15px;
  background-color: #ffffff !important;
  border: 2px solid #fceeee;
  color: black;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.dashboard-card:hover {
  box-shadow: 0 4px 8px rgba(39, 36, 68, 0.2);
}

.card-section {
  flex: 1 1; /* Equal space distribution among sections */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 20px; /* Horizontal spacing */
}

.card-row {
  font-size: 12px;
  margin-bottom: 5px;
}
.student-count {
  font-size: 12px;

}

.batchnameHead {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: bold;
  margin-bottom: 8px;
}
.icon-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 20px; /* Horizontal spacing between icons */
  margin-top: 10px; /* Adjust as needed to align icons with content */
}

.arrowImage {
  cursor: pointer;
  height: 40px;
  width: 40px;
}

.editButton {
  cursor: pointer;
}

.third-part {
  margin-top: 20px;
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .dashboard-card {
    flex-direction: column; /* Stack vertically on smaller screens */
    text-align: left;
  }

  .card-section {
    width: 100%; /* Full width for each section */
    margin: 4px 10px; /* Vertical spacing between sections */
    justify-content: center;
    align-items: center;
  }
  .icon-section {
    justify-content: center; 
    gap:80px/* Center icons horizontally on smaller screens */
  }
  .card-row{
    font-size:15px;
  
  }
  .student-count{font-size:15px;}
  .align-batch-details{
width: 200px;


  }
}

`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa,EAAE,6EAA6E;AAC9F;;AAEA;EACE,UAAU,EAAE,8BAA8B;EAC1C,kBAAkB;EAClB,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,UAAU,EAAE,8BAA8B;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,+CAA+C;AAC/D;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,YAAY,EAAE,+DAA+D;EAC7E,mBAAmB,EAAE,yDAAyD;AAChF;;AAEA,qDAAqD;AACrD;EACE,sBAAsB;EACtB,uBAAuB,EAAE,mDAAmD;AAC9E;;AAEA;EACE;IACE,mBAAmB,EAAE,+CAA+C;IACpE,YAAY,EAAE,6CAA6C;EAC7D;;EAEA;IACE,UAAU,EAAE,2BAA2B;IACvC,YAAY,EAAE,0BAA0B;EAC1C;AACF;;;AAGA,4CAA4C;AAC5C,sCAAsC;AACtC;EACE,UAAU;EACV,iBAAiB,EAAE,yBAAyB;EAC5C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;;;AAKA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,SAAO,EAAE,4CAA4C;EACrD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS,EAAE,qCAAqC;EAChD,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA,2BAA2B;AAC3B;EACE;IACE,sBAAsB,EAAE,wCAAwC;IAChE,gBAAgB;EAClB;;EAEA;IACE,WAAW,EAAE,gCAAgC;IAC7C,gBAAgB,EAAE,sCAAsC;IACxD,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,OAAO,CAAC,iDAAiD;EAC3D;EACA;IACE,cAAc;;EAEhB;EACA,eAAe,cAAc,CAAC;EAC9B;AACF,YAAY;;;EAGV;AACF","sourcesContent":[".dashboard-container {\r\n  padding: 20px;\r\n  \r\n}\r\n\r\n.dashboard-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 20px;\r\n  height: 300px; /* Set a fixed height for the content area to ensure both items are aligned */\r\n}\r\n\r\n.dashboard-image {\r\n  width: 50%; /* Takes 50% of parent width */\r\n  text-align: center;\r\n  height: 100%; /* Ensures the image div takes up full height */\r\n}\r\n\r\n.dashboard-chart {\r\n  width: 50%; /* Takes 50% of parent width */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%; /* Ensures the chart div takes up full height */\r\n}\r\n\r\n/* Adjust the image to fill the parent height */\r\n.dashboard-image img {\r\n  max-width: 100%;\r\n  height: 100%; /* Make sure the image takes the full height of its container */\r\n  object-fit: contain; /* Maintains aspect ratio and fits within the container */\r\n}\r\n\r\n/* Ensure doughnut chart canvas fills its container */\r\n.dashboard-chart canvas {\r\n  width: 100% !important;\r\n  height: 100% !important; /* Ensures the chart fills its container's height */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .dashboard-content {\r\n    flex-direction: row; /* Ensures both items stay in a row on mobile */\r\n    height: auto; /* Allow flexible height on smaller screens */\r\n  }\r\n\r\n  .dashboard-image, .dashboard-chart {\r\n    width: 50%; /* Keep them side by side */\r\n    height: auto; /* Allow flexible height */\r\n  }\r\n}\r\n\r\n\r\n/* ======================================= */\r\n/* General styling for the dashboard */\r\n.Staff-dashboard-container {\r\n  width: 90%;\r\n  margin: 20px auto; /* Center the container */\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n\r\n\r\n\r\n.dashboard-card {\r\n  width: 100%;\r\n  border-radius: 10px;\r\n  padding: 15px;\r\n  background-color: #ffffff !important;\r\n  border: 2px solid #fceeee;\r\n  color: black;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.dashboard-card:hover {\r\n  box-shadow: 0 4px 8px rgba(39, 36, 68, 0.2);\r\n}\r\n\r\n.card-section {\r\n  flex: 1; /* Equal space distribution among sections */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  margin: 0 20px; /* Horizontal spacing */\r\n}\r\n\r\n.card-row {\r\n  font-size: 12px;\r\n  margin-bottom: 5px;\r\n}\r\n.student-count {\r\n  font-size: 12px;\r\n\r\n}\r\n\r\n.batchnameHead {\r\n  font-size: 18px;\r\n  color: rgb(0, 0, 0);\r\n  font-weight: bold;\r\n  margin-bottom: 8px;\r\n}\r\n.icon-section {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  flex-direction: row;\r\n  gap: 20px; /* Horizontal spacing between icons */\r\n  margin-top: 10px; /* Adjust as needed to align icons with content */\r\n}\r\n\r\n.arrowImage {\r\n  cursor: pointer;\r\n  height: 40px;\r\n  width: 40px;\r\n}\r\n\r\n.editButton {\r\n  cursor: pointer;\r\n}\r\n\r\n.third-part {\r\n  margin-top: 20px;\r\n}\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .dashboard-card {\r\n    flex-direction: column; /* Stack vertically on smaller screens */\r\n    text-align: left;\r\n  }\r\n\r\n  .card-section {\r\n    width: 100%; /* Full width for each section */\r\n    margin: 4px 10px; /* Vertical spacing between sections */\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .icon-section {\r\n    justify-content: center; \r\n    gap:80px/* Center icons horizontally on smaller screens */\r\n  }\r\n  .card-row{\r\n    font-size:15px;\r\n  \r\n  }\r\n  .student-count{font-size:15px;}\r\n  .align-batch-details{\r\nwidth: 200px;\r\n\r\n\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
